import { useMutation } from '@tanstack/react-query'
import { useFeatureFlags } from '@node-space/hooks'
import { postConvertQuote, postConvertTransferQuote } from 'services/WalletsService'
import { postConvert } from 'types/wallets'

export const usePostConvertQuoteMutation = () => {
  const { enableV3Convert } = useFeatureFlags()

  return useMutation({
    mutationFn: (props: postConvert) =>
      enableV3Convert ? postConvertTransferQuote(props) : postConvertQuote(props),
  })
}
